import { useState, useEffect } from 'react';
import { Phone, X } from 'lucide-react';
import { useReducedMotion } from '../hooks/useScrollProgress';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const prefersReducedMotion = useReducedMotion();

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight * 0.8;
      setIsVisible(window.scrollY > heroHeight && !isDismissed);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  if (!isVisible) return null;

  return (
    <div 
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-3 ${
        prefersReducedMotion ? '' : 'animate-slide-up'
      }`}
    >
      <button
        onClick={() => setIsDismissed(true)}
        className="p-2 rounded-full bg-slate-800/80 backdrop-blur-sm border border-slate-700 text-slate-400 hover:text-white hover:border-slate-600 transition-all duration-200"
        aria-label="Dismiss CTA"
      >
        <X className="w-4 h-4" />
      </button>
      
      <a
        href="#contact"
        className="group flex items-center gap-3 px-5 py-3 rounded-full bg-gradient-to-r from-cyan-500 to-cyan-600 text-slate-900 font-semibold text-sm shadow-lg shadow-cyan-500/30 hover:shadow-cyan-500/50 hover:scale-105 transition-all duration-300"
      >
        <Phone className="w-4 h-4 group-hover:rotate-12 transition-transform duration-300" />
        <span>Book Strategy Call</span>
      </a>
    </div>
  );
}
